import {createApp} from 'vue'
const app = createApp(App);
import App from './App.vue'

import ECharts from 'vue-echarts' // 引入ECharts
import 'echarts' // 全局引入echarts

import Header from "@/components/Header";
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueRouter from './router/index';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import * as Elicons from "@element-plus/icons-vue";
import zhLocale from 'element-plus/es/locale/lang/zh-cn'
import echarts from './api/echarts'
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

import Prism from 'prismjs';

VueMarkdownEditor.use(vuepressTheme, {
    Prism,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$echarts = echarts;//vue3的挂载方式
app.component("Header", Header);
import moment from "moment";
moment.locale('zh-cn');

for (const name in Elicons) {
    app.component(name, Elicons[name]);
}

app.component('ECharts',ECharts);
app.use(ElementPlus, {
    locale: zhLocale
});
app.use(VueMarkdownEditor);
app.use(VueRouter).mount('#app');



